const autocompleteModalCloneCheck = {
  serviceType: 'Service Type',
  frequency: 'Frequency',
  mandatory: 'Service is mandatory?'
};

export default autocompleteModalCloneCheck;
